export default "__VITE_ASSET__3919f327__"